import { ChangeDetectorRef, Component, ElementRef, inject, Input, OnChanges, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialogLegacy } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { filter, Subscription } from 'rxjs';
import { CheckListService } from 'src/app/MaterialDialogs/check-list/check-list-service.service';
import { ReasonDisplayDialogComponent } from 'src/app/MaterialDialogs/reason-display-dialog/reason-display-dialog.component';
import { IAssignmentLogDetailsViewModel } from 'src/app/model/assignmentLog.model';
import { IChecklistLogsModel } from 'src/app/model/checkList.model';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { AppCategoryId } from 'src/app/service/category.model';
import { FilesService } from 'src/app/service/files.service';
import { GroupInvoicePayload } from 'src/app/service/generateInvoiceView.model';
import { NoteService } from 'src/app/service/note.service';
import { NotesService } from 'src/app/service/notes.service';
import { TripIdViewModel } from 'src/app/service/service-request';
import { ServiceRequestService } from 'src/app/service/service-request.service';
import { VendorService } from 'src/app/service/vendor.service';
import { PageName } from 'src/app/shared/enums/page-name.enum';
import { Constant, FileAttachmentTagStatusClassMap } from '../../@shared/constants/Constant';
import { CreateNote } from '../../shared/interfaces/note.interface';
import { CustomerPointOfContact } from 'src/app/shared/enums/customer-point-of-contact.enum';
import { TemplateTextDialogComponent } from '@modules/service-request-template/components/template-text-dialog/template-text-dialog.component';
import { mobileDeviceCheck } from '@helpers/mobile-check.helper';
import { ServiceRequestFileInterface } from '@interfaces/service-request/service-request-file.interface';
import { ViewFilesModalComponent } from '../../pages/v2/components/view-files-modal/view-files-modal.component';
import { DsModalService } from '@design-system/ds-base-modal/services/ds-modal.service';
import { ViewFilesModalDataInterface } from '../../pages/v2/components/view-files-modal/interfaces/view-files-modal-data.interface';
import { VIEW_FILES_MODAL_WIDTH } from '../../pages/v2/components/view-files-modal/properties/view-files-modal.properties';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { SharedUiModule } from '../../@shared/shared-ui.module';
import { UserRoleEnum } from '@enums/user-role.enum';
import { SrRedirectService } from '@services/sr-redirect.service';
import { SrTimezoneDatePipe } from '@pipes/sr-timezone-date/sr-timezone-date.pipe';
import { DsLoadingSpinnerComponent } from '@design-system/ds-loading-spinner/component/ds-loading-spinner.component';
import { getFileBaseName, getFileExtension } from '@utils/file-name.util';
import { DsIconComponent } from '@design-system/ds-icon/component/ds-icon.component';

declare var $: any;
@Component({
  selector: 'app-note-feedback-file',
  templateUrl: './note-feedback-file.component.html',
  styleUrls: ['./note-feedback-file.component.css'],
  standalone: true,
  imports: [DsIconComponent, CommonModule, FormsModule, SharedUiModule, SrTimezoneDatePipe, DsLoadingSpinnerComponent],
})
export class NoteFeedbackFileComponent implements OnInit, OnChanges, OnDestroy {
  @Input() serviceRequestId: string;
  /** SR model version (1 = legacy, 2 = V2). Drives which log endpoints are used. */
  @Input() modelVersion: number;
  @Input() detectChanges: boolean;
  @Input() header: string;
  @Input() fromPage: any;
  @Input() srIdList: GroupInvoicePayload;
  @Input() isCatering: boolean;
  @Input() isTriggerFileDetails = true;
  @ViewChild('fileInput') fileInput: ElementRef;
  // TODO: Need To remove any type from this file.
  roleName = UserRoleEnum;
  files: ServiceRequestFileInterface[] = [];
  notes: any = [];
  SRLogs: any = [];
  SRSLogs: any = [];
  assignmnetLog: IAssignmentLogDetailsViewModel[] = [];
  checkListLogs: IChecklistLogsModel[] = [];
  loader = false;
  sortOrder = true;
  prioritySorting = 'priority';
  prioritySortingFiles = 'isPinned';
  showButton: string = 'Note';
  timeZone: any;
  display: boolean = false;
  responsive: any;
  selectedPageForNotes: number = 5;
  selectedPageForFiles: number = 5;
  selectedPageForSRLogs: number = 5;
  selectedPageForSRSLogs: number = 5;
  selectedPageForAssignmnetLogs: number = 5;
  selectedPageForChecklistLogs: number = 5;
  currentPageForNotes: number = 1;
  currentPageForFiles: number = 1;
  currentPageForSRLogs: number = 1;
  currentPageForSRSLogs: number = 1;
  currentPageForAssignmnetLogs: number = 1;
  currentPageForCheckListLogs: number = 1;
  searchNotes = '';
  searchFiles = '';
  searchSRLogs = '';
  searchSRSLogs = '';
  searchAssignmnetLog = '';
  searchChecklistLogs = '';
  notesPagination: string = '';
  filePagination: string = '';
  SRLogsPaginationDes: string = '';
  SRSLogsPagination: string = '';
  assignmnetLogsPagination: string = '';
  checkListLogsPagination: string = '';
  SRLogsPagination: number = 1;
  categoryList: AppCategoryId[] = [];
  categories = [
    { id: 1, name: 'Aircraft' },
    { id: 2, name: 'Catering' },
    { id: 3, name: 'Drop off info' },
    { id: 4, name: 'Ground' },
    { id: 5, name: 'Pick up' },
    { id: 6, name: 'Service Failure' },
    { id: 7, name: 'Team' },
    { id: 8, name: 'Weather' },
    { id: 9, name: 'Others' },
  ];
  categoriesForCustomer: AppCategoryId[] = [];
  numberOfEntries = [
    { id: 1, numberOfEntries: '5' },
    { id: 2, numberOfEntries: '10' },
    { id: 3, numberOfEntries: '15' },
    { id: 4, numberOfEntries: '20' },
  ];
  numberOfEntriesForLegLogs = [5, 10, 15, 20, 50, 100];
  createNoteModel: CreateNote = new CreateNote();
  user: ILoggedInUserViewModel;
  //notes sorting......
  notesSortBy: string = 'priority';
  date: boolean = false;
  by: boolean = false;
  category: boolean = false;
  note: boolean = false;

  //SRLogs sorting
  SRLogsSortBy: string = 'createdOn';
  SRLogsOrigin = false;
  SRLogsDestination = false;
  SRLogsPreviousStatus = false;
  SRLogsUpdatedStatus = false;
  SRLogsUpdatedTime = false;
  SRLogsUpdatedBy = false;
  SRLogsOperationType = false;
  SRLogsPreviousValues = false;
  SRLogsUpdatedValues = false;

  //Assignmnet logs sorting
  assignmentLogSortBy: string = 'createdOn';
  assignmentLogLegSeqNumber = false;
  assignmentLogName = false;
  assignmentLogOrigin = false;
  assignmentLogDestination = false;
  assignmentLogUpdatedTime = false;
  assignmentLogUpdatedBy = false;
  assignmentLogOperationType = false;
  assignmentLogPreviousValues = false;
  assignmentLogUpdatedValues = false;

  //Checklist logs sorting
  checklistLogSortBy: string = 'lastUpdatedOn';
  checklistLogIndex = false;
  checklistLogName = false;
  checklistLogUpdatedOn = false;
  checklistLogUpdatedBy = false;
  checklistLogPreviousValue = false;
  checklistLogUpdatedValue = false;

  //file sorting.
  sortFileType: string = 'fileName';
  fileName: boolean = false;
  fileCreatedBy: boolean = false;
  uploadedOnColumn = false;
  fileTag: boolean = false;

  // leg logs sorting.
  legsLogSortBy: string = 'updatedOn';
  LegNumber: boolean = false;
  legOrigin: boolean = false;
  legDestination: boolean = false;
  legPreviousStatus: boolean = false;
  legUpdatedStatus: boolean = false;
  legUpdatedTime: boolean = false;
  legUpdatedBy: boolean = false;
  legOperationType: boolean = false;
  legPreviousValues: boolean = false;
  legUpdatedValues: boolean = false;
  userBusinessUnitId: any;

  isMobileDevice = true;
  selectedCategory: any = '';
  noteFeedback: string;
  cateringLogLength: number = 0;
  fileAttachmentTagStatusClass = FileAttachmentTagStatusClassMap;
  chooseFile: ServiceRequestFileInterface[] = [];
  totalCountFiles = 0;
  private _subscriptions: Subscription = new Subscription();

  private readonly dsModalService = inject(DsModalService);

  constructor(
    private _toastr: ToastrService,
    private _vendorService: VendorService,
    private _noteService: NoteService,
    private _fileService: FilesService,
    private _serviceRequestService: ServiceRequestService,
    private _checklistService: CheckListService,
    private _cdr: ChangeDetectorRef,
    private _notesService: NotesService,
    private _dialog: MatDialogLegacy,
    private readonly _srRedirectService: SrRedirectService,
  ) {
    this._serviceRequestService.legRecordUpdate.subscribe((value) => {
      if (this._srRedirectService.isV2(this.modelVersion)) {
        this.getV2Logs(value);
      } else {
        this.getServiceRequestStepLogs(value);
      }
    });
    this._serviceRequestService.timZoneChange.subscribe((value) => {
      this.timeZone = Constant.selectedTimeZoneShortValue;
    });
    this.timeZone = Constant.selectedTimeZoneShortValue;

    this._checklistService.triggerGetChekListLogMethod.subscribe((response: string) => {
      this.getChecklistLogs(response);
    });
  }
  isInternalReadOnly: boolean = false;
  isAdmin: boolean = false;
  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('user'));
    this.isInternalReadOnly = this.user.role === UserRoleEnum.INTERNAL_READONLY;
    this.isAdmin =
      this.user.role === UserRoleEnum.EXECUTIVE_ADMIN ||
      this.user.role === UserRoleEnum.COORDINATOR ||
      this.user.role === UserRoleEnum.MANAGEMENT ||
      this.user.role === UserRoleEnum.ACCOUNTING;
    this.isMobileDevice = mobileDeviceCheck();

    this._notesService.$fetchNotes.subscribe((type) => {
      type == 'Priority' ? this.getNotesByID(this.serviceRequestId, this.userBusinessUnitId) : this.getAllNotes();
    });
  }

  ngOnChanges() {
    this.user = JSON.parse(localStorage.getItem('user'));
    if (this.fromPage == 'Itinary') this.loader = false;
    if (this.srIdList != undefined || this.srIdList != null) {
      this.serviceRequestId = this.srIdList.serviceRequestID[0];
      this.getTripIdByServiceRequestList(this.srIdList);
      this.getGroupNotes(this.srIdList, this.user.businessUnitId);
    } else {
      this.userBusinessUnitId = this.user.businessUnitId;
      this.getNotesByID(this.serviceRequestId, this.userBusinessUnitId);
      this.getFile(this.fromPage, this.serviceRequestId);
    }
    this.openAddNoteFeedbackModel(this.fromPage);
    this.popupFilterFileType = this.chooseFile;
    this.getCustomerCategory();
    if (this.srIdList == undefined || this.srIdList == null) {
      this.loadServiceRequestLogs();
    }
    if (this.fromPage == 'Preview') {
      this.getChecklistLogs(this.serviceRequestId);
    }
    this.filePagination = Constant.showPaginationMessage(this.files.length, this.currentPageForFiles, this.selectedPageForFiles);

    if (this.serviceRequestId) {
      this.getFile(this.fromPage, this.serviceRequestId);
    }
  }

  ngOnDestroy(): void {
    this._subscriptions.unsubscribe();
  }

  trackByFn(index: number, item: any): string {
    return item.fileId;
  }

  cancellationReasonPopUp(srCancellationReasonId: string): void {
    this._dialog.open(ReasonDisplayDialogComponent, {
      minWidth: '25%',
      maxWidth: '20%',
      position: {
        top: '1rem',
      },
      data: srCancellationReasonId,
    });
  }

  openAddNoteFeedbackModel(head: string) {
    this.header = head;
    if (this.fromPage != 'customer' || this.fromPage == 'createItenary') this.getCategoryList();
    else this.getCustomerCategory();
  }

  deleteNote(noteId: string) {
    this._noteService.deleteNotes(noteId).subscribe((response) => {
      if (this.srIdList != null || this.srIdList != undefined) {
        this.getGroupNotes(this.srIdList, this.user.businessUnitId);
      } else {
        this.getAllNotes();
      }
    });
  }

  getAllNotes() {
    this._noteService.getAllServiceRequestLevelNote(this.serviceRequestId).subscribe((response) => {
      this.notes = response;
      this.notesPagination = Constant.showPaginationMessage(this.notes.length, this.currentPageForNotes, this.selectedPageForNotes);
      this._cdr.detectChanges();
    });
  }

  saveNoteFeedbackData() {
    var date =
      new Date().getDate() +
      '/' +
      (new Date().getMonth() + 1) +
      '/' +
      new Date().getFullYear() +
      ' ' +
      new Date().getHours() +
      ':' +
      new Date().getMinutes();
    if (this.noteFeedback != '' && this.noteFeedback != undefined) {
      if (this.header == 'Note') {
        this.fillNoteData();
      }
    } else {
      this.errorMessage('Please fill all required fields!');
    }
  }
  fillNoteData() {
    if (this.selectedCategory != '' && this.selectedCategory != undefined && this.noteFeedback != '' && this.noteFeedback != undefined) {
      this.loader = true;
      this.createNoteModel.createdBy = this.user['memberId'];
      this.createNoteModel.category = this.selectedCategory;
      this.createNoteModel.noteDescription = this.noteFeedback;
      this.createNoteModel.noteType = this.user.memberType == 'Vendor' ? 'VendorNote' : 'ServiceRequest';
      this.createNoteModel.businessUnitId = this.serviceRequestId;
      this.createNoteModel.userBusinessUnitId = this.user['businessUnitId'];
      this._noteService.createNote(this.createNoteModel).subscribe((response) => {
        this.display = false;
        this.loader = false;
        if (this.srIdList != undefined || this.srIdList != null) this.getGroupNotes(this.srIdList, this.user.businessUnitId);
        else this.getAllNotes();
      });
      this.selectedCategory = '';
      this.noteFeedback = '';
      this.selectedTripId = undefined;
      $('#addNoteFeedback').modal('hide');
      this.successMessage('Note Added SuccessFully!');
      this.notesPagination = Constant.showPaginationMessage(this.notes.length, this.currentPageForNotes, this.selectedPageForNotes);
    } else {
      this.errorMessage('Please fill all required fields!');
    }
  }

  successMessage(msg: string) {
    this._toastr.success(msg, 'Success!', {
      timeOut: 2000,
      positionClass: 'toast-top-center',
    });
  }
  errorMessage(msg: string) {
    this._toastr.error(msg, 'Error', {
      timeOut: 2000,
      positionClass: 'toast-top-center',
    });
  }
  oldFileData = [];

  openCreateFileModal(): void {
    this.dsModalService
      .open<ViewFilesModalComponent, ViewFilesModalDataInterface>(ViewFilesModalComponent, {
        width: VIEW_FILES_MODAL_WIDTH,
        data: {
          serviceRequestId: this.serviceRequestId,
          fromPage: this.fromPage,
          isFileEditable: true,
          isTagRequired: true,
        },
      })
      .afterClosed()
      .pipe(filter(Boolean))
      .subscribe(() => {
        this.getFile(this.fromPage, this.serviceRequestId);
      });
  }

  openEditFileModal(file: ServiceRequestFileInterface): void {
    this.dsModalService
      .open<ViewFilesModalComponent, ViewFilesModalDataInterface>(ViewFilesModalComponent, {
        width: VIEW_FILES_MODAL_WIDTH,
        data: {
          serviceRequestId: this.serviceRequestId,
          fromPage: this.fromPage,
          selectedFile: file,
          isFileEditable: true,
          isTagRequired: true,
        },
      })
      .afterClosed()
      .pipe(filter(Boolean))
      .subscribe(() => {
        this.currentPageForFiles = 1;
        this.getFile(this.fromPage, this.serviceRequestId);
      });
  }

  popupFilterFileType = [];
  copyArr = [];
  searchText: string;
  editAllFile1: boolean = false;

  closeViewFileModel(flag: boolean) {
    this.chooseFile.forEach((item) => {
      item.isEditable = false;
    });
    this.editAllFile1 = false;
    if (flag == true) this.chooseFile = [...this.oldFileData];
    this.filePagination = Constant.showPaginationMessage(this.files.length, this.currentPageForFiles, this.selectedPageForFiles);
  }

  editAllFile() {
    this.copyArr = [...this.chooseFile].map((item) => ({ ...item }));
    this.chooseFile.forEach((item) => {
      item.isEditable = true;
    });
    this.editAllFile1 = true;
  }

  closeAll() {
    this.chooseFile = this.copyArr;
    this.editAllFile1 = false;
  }

  removeFile(id, index?) {
    if (id !== 0) {
      this._vendorService.deletedFile('fileId=' + id).subscribe((response) => {
        this._toastr.success('Deleted file Successfully', 'Success', { positionClass: 'toast-top-center', timeOut: 6000 });
        this.ngOnChanges();
      });
    } else {
      this.chooseFile.splice(index, 1);
    }
  }

  selectMemberPage(cardName: string) {
    switch (cardName) {
      case 'Notes':
        this.currentPageForNotes = 1;
        this.notesPagination = Constant.showPaginationMessage(this.notes.length, this.currentPageForNotes, this.selectedPageForNotes);
        break;
      case 'SRLogs':
        this.currentPageForSRLogs = 1;
        this.SRLogsPaginationDes = Constant.showPaginationMessage(
          this.SRLogs.length,
          this.currentPageForSRLogs,
          this.selectedPageForSRLogs,
        );
        break;
      case 'SRSLogs':
        this.currentPageForSRSLogs = 1;
        this.SRSLogsPagination = Constant.showPaginationMessage(
          this.SRSLogs.length,
          this.currentPageForSRSLogs,
          this.selectedPageForSRSLogs,
        );
        break;
      case 'AssignmnetLogs':
        this.currentPageForAssignmnetLogs = 1;
        this.assignmnetLogsPagination = Constant.showPaginationMessage(
          this.assignmnetLog.length,
          this.currentPageForAssignmnetLogs,
          this.selectedPageForAssignmnetLogs,
        );
        break;
      case 'CheckListLogs':
        this.currentPageForCheckListLogs = 1;
        this.checkListLogsPagination = Constant.showPaginationMessage(
          this.checkListLogs.length,
          this.currentPageForCheckListLogs,
          this.selectedPageForChecklistLogs,
        );
        break;
      default:
        this.currentPageForFiles = 1;
        this.getFile(this.fromPage, this.serviceRequestId);
        break;
    }
  }

  currentPageChange(cardName: string) {
    switch (cardName) {
      case 'Notes':
        this.notesPagination = Constant.showPaginationMessage(this.notes.length, this.currentPageForNotes, this.selectedPageForNotes);
        break;
      case 'SRLogs':
        this.SRLogsPaginationDes = Constant.showPaginationMessage(
          this.SRLogs.length,
          this.currentPageForSRLogs,
          this.selectedPageForSRLogs,
        );
        break;
      case 'SRSLogs':
        this.SRSLogsPagination = Constant.showPaginationMessage(
          this.SRSLogs.length,
          this.currentPageForSRSLogs,
          this.selectedPageForSRSLogs,
        );
        break;
      case 'AssignmnetLogs':
        this.assignmnetLogsPagination = Constant.showPaginationMessage(
          this.assignmnetLog.length,
          this.currentPageForAssignmnetLogs,
          this.selectedPageForAssignmnetLogs,
        );
        break;
      case 'CheckListLogs':
        this.checkListLogsPagination = Constant.showPaginationMessage(
          this.checkListLogs.length,
          this.currentPageForCheckListLogs,
          this.selectedPageForChecklistLogs,
        );
        break;
      default:
        this.filePagination = Constant.showPaginationMessage(this.files.length, this.currentPageForFiles, this.selectedPageForFiles);
        break;
    }
  }

  onPageChangeFiles(value: number): void {
    this.currentPageForFiles = value;
    this.currentPageChange('Files');
    this.getFile(this.fromPage, this.serviceRequestId);
  }

  getCategoryList() {
    if (this._vendorService.appCategoryIdList$.value.length > 0) {
      this.categoryList = this._vendorService.appCategoryIdList$.value;
    } else {
      this._vendorService.getAppCategoryData().subscribe((response) => {
        this.categoryList = response;
      });
    }
  }

  getCustomerCategory() {
    this._vendorService.getCustomerNoteCategory().subscribe((response) => {
      this.categoriesForCustomer = response;
    });
  }

  clearData() {
    this.selectedCategory = '';
    this.noteFeedback = '';
    this.selectedTripId = undefined;
    this.display = false;
  }

  multipleFileUpload: any;
  path: string = '';
  deletedFile = [];
  noteSize(value: string) {
    if (this.noteFeedback == '' || this.noteFeedback == null) {
      this.display = false;
    } else if (value.length > 500) {
      this.display = true;
    } else this.display = false;
  }

  getFile(fromPage: string, businessUnitId: string): void {
    if (fromPage === 'Preview') {
      fromPage = 'Itinary';
    }

    this._fileService.fetchFiles(fromPage, businessUnitId, this.currentPageForFiles, this.selectedPageForFiles).subscribe((response) => {
      this.files = response.items.map((item) => {
        return {
          ...item,
          fileName: getFileBaseName(item.displayName),
          extension: getFileExtension(item.displayName),
        };
      });
      this.totalCountFiles = response.count;
      this.chooseFile = this.files;
      this.filePagination = Constant.showPaginationMessage(this.totalCountFiles, this.currentPageForFiles, this.selectedPageForFiles);
    });
    this.chooseFile = this.files;
    this.filePagination = Constant.showPaginationMessage(this.files.length, this.currentPageForFiles, this.selectedPageForFiles);
  }

  pinItem(item): void {
    this._fileService.pinFile(item.fileId).subscribe(() => {
      this.currentPageForFiles = 1;
      this.getFile(this.fromPage, this.serviceRequestId);
    });
  }

  getNotesByID(businessUnitID: string, userBusinessUnitId: string) {
    this.notes = [];
    this._noteService.getAllServiceRequestLevelNote(businessUnitID).subscribe({
      next: (response) => {
        this.notes = [...response];
        this.notesPagination = Constant.showPaginationMessage(this.notes.length, this.currentPageForNotes, this.selectedPageForNotes);
        this.loader = false;
        this._cdr.detectChanges();
      },
      error: () => {
        this.loader = false;
      },
    });
  }

  getServiceRequestLogs(businessUnitID: string) {
    this.SRLogs = [];
    this._serviceRequestService.getServiceRequestLogs(businessUnitID).subscribe({
      next: (response) => {
        this.SRLogs = response;
        this.SRLogsPaginationDes = Constant.showPaginationMessage(
          this.SRLogs.length,
          this.currentPageForSRLogs,
          this.selectedPageForSRLogs,
        );
        this.loader = false;
      },
      error: () => {
        this.loader = false;
      },
    });
  }

  getServiceRequestStepLogs(businessUnitID: string) {
    this.SRSLogs = [];
    this._serviceRequestService.getServiceRequestStepsLogs(businessUnitID).subscribe({
      next: (response) => {
        this.SRSLogs = response;
        this.SRSLogsPagination = Constant.showPaginationMessage(
          this.SRSLogs.length,
          this.currentPageForSRSLogs,
          this.selectedPageForSRSLogs,
        );
        this.loader = false;
      },
      error: () => {
        this.loader = false;
      },
    });
  }
  getAssignmentLogDetails(businessUnitID: string) {
    this.SRSLogs = [];
    this._serviceRequestService.getAssignmentLogDetails(businessUnitID).subscribe({
      next: (response) => {
        this.assignmnetLog = response;
        this.updateNameForCustomerAndSubCustomer();
        this.assignmnetLogsPagination = Constant.showPaginationMessage(
          this.assignmnetLog.length,
          this.currentPageForAssignmnetLogs,
          this.selectedPageForAssignmnetLogs,
        );
      },
      error: () => {
        this.loader = false;
      },
    });
  }
  /**
   * Selects the log source and (re)loads the panel on every ngOnChanges, matching the original
   * refresh-on-input behavior (e.g. the legacy itinerary page toggles an input on leg add/delete
   * to refresh SR + assignment + leg logs). This intentionally does NOT dedupe: same-endpoint
   * refetches on input changes are expected and cheap.
   *
   * The V1/V2 race is prevented upstream by the parent (preview-itinerary-detail) which only
   * renders this component once the SR detail — and therefore modelVersion — has resolved
   * (`*ngIf="... && isServiceRequestLoaded"`). That guarantees the branch below always sees the
   * correct model version, so a V2 SR never hits the legacy endpoints. Reuse contexts where
   * modelVersion is undefined (group-invoice, legacy itinerary page) take the legacy branch, as
   * before.
   */
  private loadServiceRequestLogs(): void {
    if (!this.serviceRequestId) {
      return;
    }

    if (this._srRedirectService.isV2(this.modelVersion)) {
      this.getV2Logs(this.serviceRequestId);
    } else {
      this.getServiceRequestLogs(this.serviceRequestId);
      this.getServiceRequestStepLogs(this.serviceRequestId);
      this.getAssignmentLogDetails(this.serviceRequestId);
    }
  }

  /**
   * V2 branch: a single call reconstructs SR logs, leg logs and assignment logs from the
   * itinerary audit trail. Values are guarded against null/JSON-shaped content so the existing
   * (legacy) log templates render without console or missing-key errors.
   */
  private getV2Logs(serviceRequestId: string): void {
    if (!serviceRequestId) {
      return;
    }
    this.SRLogs = [];
    this.SRSLogs = [];
    this.assignmnetLog = [];
    this._serviceRequestService.getServiceRequestAuditLogs(serviceRequestId).subscribe({
      next: (response) => {
        this.SRLogs = response?.serviceRequestLogs ?? [];
        this.SRSLogs = response?.legLogs ?? [];
        this.assignmnetLog = response?.assignmentLogs ?? [];
        this.updateNameForCustomerAndSubCustomer();
        this.SRLogsPaginationDes = Constant.showPaginationMessage(
          this.SRLogs.length,
          this.currentPageForSRLogs,
          this.selectedPageForSRLogs,
        );
        this.SRSLogsPagination = Constant.showPaginationMessage(
          this.SRSLogs.length,
          this.currentPageForSRSLogs,
          this.selectedPageForSRSLogs,
        );
        this.assignmnetLogsPagination = Constant.showPaginationMessage(
          this.assignmnetLog.length,
          this.currentPageForAssignmnetLogs,
          this.selectedPageForAssignmnetLogs,
        );
        this.loader = false;
      },
      error: () => {
        this.loader = false;
      },
    });
  }

  getGroupNotes(srIdList: GroupInvoicePayload, businessUnitId: string) {
    this._noteService.getGroupNotes(srIdList, businessUnitId).subscribe({
      next: (response) => {
        this.notes = [];
        this.notes = [...response];
        this.notesPagination = Constant.showPaginationMessage(this.notes.length, this.currentPageForNotes, this.selectedPageForNotes);
        this.loader = false;
      },
      error: () => {
        this.loader = false;
      },
    });
  }
  selectedTripId: any;
  tripIdListByServiceRequest: TripIdViewModel[];
  getTripIdByServiceRequestList(srIdList: GroupInvoicePayload) {
    this._serviceRequestService.getTripIdByServiceRequestList(srIdList).subscribe({
      next: (response) => {
        this.tripIdListByServiceRequest = response;
      },
      error: (error) => {
        this._toastr.warning('Unable to load trips for these service requests. Please try again.', 'Warning', {
          timeOut: 6000,
          positionClass: 'toast-top-center',
        });
      },
    });
  }

  changeTripId(event) {
    this.serviceRequestId = event.target.value;
  }

  saveFinanceNote() {
    if (this.tripIdListByServiceRequest != undefined && this.tripIdListByServiceRequest.length == 1 && this.selectedTripId == undefined) {
      this.fillNoteData();
    } else if (
      this.tripIdListByServiceRequest != undefined &&
      this.tripIdListByServiceRequest.length > 1 &&
      this.selectedTripId != undefined
    ) {
      this.fillNoteData();
    } else {
      this.errorMessage('Please fill all required fields!');
    }
  }

  notePriority(note) {
    const priority = note.priority != null ? !note.priority : true;
    this._noteService.notePriority(note.noteID, priority).subscribe({
      next: (response) => {
        this.userBusinessUnitId = this.user.businessUnitId;
        this.getNotesByID(this.serviceRequestId, this.userBusinessUnitId);
        this.successMessage('Note Priority Updated Successfully');
      },
      error: () => {
        this._toastr.warning('Failed to update note priority. Please try again', 'Warning', {
          timeOut: 6000,
          positionClass: 'toast-top-center',
        });
      },
    });
  }

  getChecklistLogs(serviceRequestId: string) {
    this._checklistService.getCheckListLogs(serviceRequestId).subscribe({
      next: (response) => {
        this.checkListLogs = response.data != null ? response.data : [];
        this.checkListLogsPagination = Constant.showPaginationMessage(
          this.checkListLogs.length,
          this.currentPageForCheckListLogs,
          this.selectedPageForChecklistLogs,
        );
      },
      error: () => {
        this._toastr.warning('Something Went Wrong! Could not get the checklist logs!', 'Warning', {
          timeOut: 6000,
          positionClass: 'toast-top-center',
        });
      },
    });
  }

  cateringLogsLength(event: number): void {
    this.cateringLogLength = event;
  }

  isCustomerOrVendorPage(): boolean {
    return this.fromPage !== PageName.vendor && this.fromPage !== PageName.customer;
  }

  updateNameForCustomerAndSubCustomer() {
    this.assignmnetLog.forEach((log) => {
      // V2 audit rows may carry null or JSON-shaped updatedValues; guard so string parsing below
      // (legacy V1 point-of-contact format) never throws.
      const updatedValues = log.updatedValues ?? '';
      switch (true) {
        case updatedValues.includes(CustomerPointOfContact.customer) && !updatedValues.includes(CustomerPointOfContact.subCustomer):
          log.assignedMember = updatedValues.replace(CustomerPointOfContact.customer, '').trim();
          break;
        case updatedValues.includes(CustomerPointOfContact.subCustomer) && !updatedValues.includes('|'):
          log.assignedMember = updatedValues.replace(CustomerPointOfContact.subCustomer, '').trim();
          break;
        case updatedValues.includes(CustomerPointOfContact.customer) &&
          updatedValues.includes(CustomerPointOfContact.subCustomer) &&
          updatedValues.includes('|'):
          log.customerPointOfContacts = updatedValues.split('|');
          break;
      }
    });
  }

  showTemplateTextDialog(templateId: string): void {
    this._dialog.open(TemplateTextDialogComponent, {
      minWidth: '45%',
      maxWidth: '50vw',
      panelClass: 'dialog-wrap',
      data: {
        templateId,
      },
    });
  }

  sortColumn(fieldName: string, fieldValue: string): void {
    this.sortFileType = fieldValue;
    this.sortOrder = !this.sortOrder;
    this[fieldName] = !this[fieldName];
  }

  downloadFile(file: ServiceRequestFileInterface): void {
    if (!file.fileName) return;
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.href = file.filePath;
    a.download = file.displayName;
    a.click();
    document.body.removeChild(a);
  }
}
